import React, { useEffect, useState } from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import ErrorRoundedIcon from '@mui/icons-material/ErrorRounded';
import RemoveCircleOutlineRoundedIcon from '@mui/icons-material/RemoveCircleOutlineRounded';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import { useTheme } from '@mui/material/styles';
import Divider from '@mui/material/Divider';
import { Chip } from '@mui/material';

export const CurrentMetricOverview = (props: any) => {
    const theme = useTheme();
    const {
        title,
        percentage,
        target,
        subtitle,
        secondaryTitle,
        metric,
        caseCount,
    } = props;
    const [targetValue, setTargetValue] = useState('N/A');
    const [targetColor, setTargetColor] = useState('#666F6E');
    const [targetIcon, setTargetIcon] = useState(
        <RemoveCircleOutlineRoundedIcon style={{ color: 'white' }} />
    );
    const [selectedMetric, setSelectedMetric] = useState(null);

    useEffect(() => {
        if (
            selectedMetric &&
            selectedMetric.currentMetricsTitle === metric.currentMetricsTitle
        ) {
            setSelectedMetric(metric);
        }
    }, [metric, selectedMetric, setSelectedMetric]);

    useEffect(() => {
        if (percentage !== null) {
            if (percentage >= target) {
                setTargetValue('On Track');
                setTargetColor('#008577');
                setTargetIcon(
                    <CheckCircleRoundedIcon style={{ color: 'white' }} />
                );
            } else if (Math.abs(target - percentage) < 16) {
                setTargetValue('Near Target');
                setTargetColor('#D37E2F');
                setTargetIcon(<ErrorRoundedIcon style={{ color: 'white' }} />);
            } else if (isNaN(percentage)) {
                setTargetValue('Calculating...');
                setTargetColor('gray');
                setTargetIcon(null);
            } else {
                setTargetValue('Off Track');
                setTargetColor('#D32F2F');
                setTargetIcon(<CancelRoundedIcon style={{ color: 'white' }} />);
            }
        }
    }, [percentage, target]);

    return (
        <Paper
            elevation={3}
            style={{ height: '100%', padding: 15, borderRadius: 5 }}
            sx={{
                backgroundColor:
                    theme.palette.mode === 'light'
                        ? '#F4F6FC !important'
                        : '#353A39 !important',
            }}
        >
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Grid
                        container
                        justifyContent={'space-between'}
                        alignItems={'center'}
                    >
                        <Grid item xs={12}>
                            <Typography
                                variant={'h6'}
                                sx={{ fontWeight: 'bold' }}
                            >
                                {title}
                            </Typography>
                            <Typography variant={'caption'}>
                                Case Count
                            </Typography>
                            <Typography
                                variant={'h4'}
                                sx={{ fontWeight: 'bold' }}
                            >
                                {caseCount ? caseCount : '---'}
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Divider />
                </Grid>
                {secondaryTitle && (
                    <Grid item xs={12}>
                        <Typography variant={'h6'} sx={{ fontWeight: 'bold' }}>
                            {secondaryTitle}
                        </Typography>
                        <Typography variant={'caption'}>{subtitle}</Typography>
                    </Grid>
                )}

                {target && (
                    <Grid item xs={12}>
                        <Typography
                            variant={'h3'}
                            color={targetColor}
                            style={{ fontWeight: 'bold' }}
                        >
                            {percentage !== null &&
                            percentage !== undefined &&
                            !isNaN(percentage)
                                ? `${percentage.toFixed(1)}%`
                                : '---%'}
                        </Typography>
                        <Typography variant={'caption'} color={'inherit'}>
                            <b>Target:</b> {target.toFixed(1)}%
                        </Typography>
                    </Grid>
                )}

                {title !== 'Under Post-Treatment Surveillance' && (
                    <Grid item xs={12}>
                        <Chip
                            avatar={targetIcon}
                            label={targetValue}
                            variant="filled"
                            style={{
                                width: '100%',
                                backgroundColor: targetColor,
                                color: 'white',
                                padding: 20,
                                borderRadius: 0,
                                fontWeight: 'bold',
                            }}
                        />
                    </Grid>
                )}
            </Grid>
        </Paper>
    );
};

export default CurrentMetricOverview;
